<form [formGroup]="form" class="billing-preferences">
	<nb-toggle class="toggle-row" [checked]="order.billingInformations.sameCompanyAndContactPersonAsProvided"
			   status="primary"
			   formControlName="sameCompanyAndContactPersonAsProvided"
			   (checkedChange)="updateFormControl('sameCompanyAndContactPersonAsProvided', $event)">
		Address and contact information same as already given
	</nb-toggle>

	<ng-content></ng-content>

	<div class="radio-row">
		<div class="radio-with-question">
			<div class="radio-column">
				<nb-radio-group [name]="'purchaseNumber'"
								formControlName="isPurchaseNumberRequiredForPayment"
								(valueChange)="updatePaymentRequired($event)"
								[disabled]="shouldDisableRadio('isPurchaseNumberRequiredForPayment')"
								status="primary">
					<nb-radio [value]="true">Yes</nb-radio>
					<nb-radio [value]="false">No</nb-radio>
				</nb-radio-group>
			</div>
			<div class="radio-description-column">
				<span>Is Purchase Order number required for payment?</span>
			</div>
		</div>
	</div>

	@if (order.billingInformations.isPurchaseNumberRequiredForPayment) {
		<div class="text-row">
			<label class="text-row-label purchase-label">PURCHASE ORDER NUMBER</label>
			<input type="text" nbInput fullWidth formControlName="purchaseOrderNumber" [value]="order.billingInformations.purchaseOrderNumber || ''" placeholder="172942-1">
			@if (isInvalid('purchaseOrderNumber')) {
				<div class="validation-message">{{ getValidationErrors('purchaseOrderNumber') | async }}</div>
			}
		</div>
	}

	@if (order.billingInformations.isPurchaseNumberRequiredForPayment) {
		<div class="radio-row">
			<div class="radio-with-question">
				<div class="radio-column">
					<nb-radio-group [name]="'expenses'"
									formControlName="coverTravelExpenses"
									status="primary"
									[disabled]="shouldDisableRadio('coverTravelExpenses')">
						<nb-radio [value]="true">Yes</nb-radio>
						<nb-radio [value]="false">No</nb-radio>
					</nb-radio-group>
				</div>
				<div class="radio-description-column">
					<span>Does Purchase Order cover travel expenses at cost in addition to professional fee?</span>
				</div>
			</div>
		</div>
	}

	<div class="text-row">
		<span class="text-row-label">ADDITIONAL BILLING INFORMATION</span>
		<span class="optional-label">optional</span>
		<text-area class="additional-billing-info" [form]="form" [formService]="formService" [autoGrowEnabled]="true" [controlName]="'additionalInformation'"
				   [placeholder]="'type in any additional billing information'" [htmlPrefix]="'additionalInformation'"></text-area>
	</div>

</form>
